'use strict';

// 305 Forged landing page photo viewer (WI-68).
//
// sections/dha-collection-series.liquid renders every photo as a plain link to the full image
// (data-dha-series-open, data-index) and gives each series its complete, ordered photo list as a
// JSON island (data-dha-series-data). This script opens the SAME viewer the product page's Wheel
// Gallery uses - DHAProductGallery.createViewer in assets/dha-product-gallery.js, loaded first by
// the section - over that list: previous / next, arrow keys, swipe, Escape, Close, Index view,
// focus into the viewer and back to the photo that opened it.
//
// Without JavaScript (or if the shared viewer is missing) the links keep opening the image.

(function () {
  // Several sections can load this script on one page (the homepage series galleries and the Product Study):
  // wire the page once.
  if (window.__dhaSeriesViewerWired) return;
  window.__dhaSeriesViewerWired = true;

  function mountSeries(section) {
    var lib = window.DHAProductGallery;
    var island = section.querySelector('script[data-dha-series-data]');
    if (!lib || typeof lib.createViewer !== 'function' || !island) return;

    var data;
    try {
      data = JSON.parse(island.textContent);
    } catch (error) {
      if (window.console && console.warn) console.warn('DHA collection series: could not read the photo list.', error);
      return;
    }
    var items = (data.photos || [])
      .filter(function (photo) { return !!photo.src; })
      .map(function (photo, n, all) {
        return { url: photo.src, alt: photo.alt || (data.title || 'Photo') + ' – photo ' + (n + 1) + ' of ' + all.length };
      });
    if (!items.length) return;

    var title = data.title || '';
    var viewer = lib.createViewer({
      items: items,
      ariaLabel: (title ? title + ' ' : '') + 'photo gallery',
      className: 'dha-pgv--series',
      title: title,
    });

    Array.prototype.forEach.call(section.querySelectorAll('[data-dha-series-open]'), function (link) {
      link.addEventListener('click', function (event) {
        // Leave modified and non-primary clicks (open in a new tab) alone.
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var index = parseInt(link.getAttribute('data-index'), 10);
        if (isNaN(index) || index < 0 || index >= items.length) return;
        event.preventDefault();
        // "View all NN photos" opens on the index of every photo; a photo opens on itself.
        var viewAll = link.classList.contains('dha-cs__all');
        viewer.open(viewAll ? 0 : index, viewAll && items.length > 1, link);
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dha-series]'), mountSeries);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
